function clearSelectionForm() {
  // キーワード入力フォームの値をクリア
  const textInput = document.querySelector('.projects-page-list-section__search-input:not(.projects-page-list-section__search-input--dropdown)');
  if (textInput) {
    textInput.value = '';
  }

  // 2つのプルダウンの選択をクリア（先頭の項目を選択状態に）
  document.querySelectorAll('.projects-page-list-section__search-input--dropdown').forEach(select => {
    select.selectedIndex = 0;
  });
}

// onclick属性から呼び出せるように、関数をグローバルスコープに設定
window.clearSelectionForm = clearSelectionForm;
